import { Skeleton } from '@/shared/components/ui/skeleton';

export function IntegrationsSkeleton() {
  return (
    <div className="space-y-4" data-testid="settings-integrations-skeleton">
      {[0, 1].map((i) => (
        <div key={i} className="rounded-lg border border-border p-4 space-y-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Skeleton className="size-9 rounded-full" />
              <div className="space-y-1.5">
                <Skeleton className="h-4 w-48" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
            <Skeleton className="h-8 w-24" />
          </div>
          <div className="space-y-2 pl-12">
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-full" />
          </div>
        </div>
      ))}
    </div>
  );
}
